"use client";

import * as React from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card, CardContent } from "@/components/ui/card";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Mail } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
function SubscribeForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="text-center p-6 bg-primary-light rounded-md">
        <p className="text-primary-700 font-medium mb-4">{successMessage}</p>
        <Button onClick={resetForm} variant="outline" className="hover:-translate-y-0.5 hover:shadow-medium transition-all duration-[120ms]">
          Subscribe Another Email
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit}>
      <div className="space-y-4">
        <FormField control={control} name="email" rules={{
        required: "Email is required",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Please enter a valid email address"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="sr-only">Email Address</FormLabel>
              <FormControl>
                <div className="relative">
                  <Mail className="absolute left-3 top-1/2 -translate-y-1/2 size-5 text-muted-foreground pointer-events-none" />
                  <Input type="email" placeholder="Enter your email address" disabled={isSubmitting} className="pl-11 h-11 transition-all duration-[80ms] focus-visible:ring-2 focus-visible:ring-primary focus-visible:border-primary" {...field} />
                </div>
              </FormControl>
              <FormMessage />
            </FormItem>} />

        {submitError && <div className="p-4 bg-red-50 border border-red-200 rounded-md">
            <p className="text-red-800 text-sm">{submitError}</p>
          </div>}

        <Button type="submit" disabled={isSubmitting} className="w-full h-11 bg-primary hover:bg-primary-hover text-foreground-primary font-semibold rounded-md shadow-soft transition-all duration-[120ms] hover:-translate-y-0.5 hover:shadow-medium active:translate-y-0">
          {isSubmitting ? "Subscribing..." : "Subscribe"}
        </Button>

        <p className="text-xs text-muted-foreground text-center mt-6">
          We respect your privacy. Unsubscribe at any time.
        </p>
      </div>
    </Form>;
}
export default function SubscribeCta() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    once: true,
    threshold: 0.2
  });
  return <section className="bg-dark-background py-16 md:py-20">
      <div className="container mx-auto px-4 md:px-8 max-w-2xl">
        <div ref={ref} className={`transition-all duration-[200ms] ease-[cubic-bezier(0.4,0,0.2,1)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <Card className="bg-light-background shadow-medium border-0">
            <CardContent className="p-8 md:p-10">
              <div className="text-center mb-6">
                <h2 className="text-2xl md:text-3xl font-semibold text-white mb-3">
                  Stay Connected
                </h2>
                <p className="text-white text-sm md:text-base">
                  Subscribe to our newsletter for dental health tips and updates from Alpha Dental
                </p>
              </div>

              <FormProvider formId="newsletter-subscription-cta" sectionName="subscribe-cta" defaultValues={{
              email: ""
            }} validationRules={{
              email: {
                required: true,
                pattern: "email"
              }
            }} submitText="Subscribe" successMessage="Thank you for subscribing to our newsletter!">
                <SubscribeForm />
              </FormProvider>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
}